// Actual auth token, httponly (not accessible by JavaScript)
export const AUTH_TOKEN: string = "auth_token";
// Token which can be used by JavaScript to see if auth_token is set
export const AUTH_TOKEN_PRESENT: string = "auth_token_present";
// Token which contains the metadata of the auth token
export const AUTH_TOKEN_META_DATA: string = "auth_token_meta_data";

export enum ImpersonationErrorReason {
  ALREADY_IMPERSONATING = "impersonate_users.already_impersonating",
  USER_ACTION_BLOCKED = "impersonate_users.user_action_blocked",
}

export type AuthTokenMetaData = {
  sub: number;
  userId: number;
  actorId?: number;
  deviceInventoryId?: string;
  backupDeviceId?: number;
  iat?: number;
  exp: number;
};
